// DS: i3.6
import React from 'react';
import IconWrap from '../IconWrap';
const ArrowUp = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M3.404 14.96a1 1 0 101.414 1.414l7.072-7.07 7.07 7.07a1 1 0 101.415-1.414l-7.779-7.778a1 1 0 00-1.414 0L3.404 14.96z",
        clipRule: "evenodd"
    })));
ArrowUp.displayName = 'ArrowUp';
export default ArrowUp;
